// extracted by mini-css-extract-plugin
module.exports = {"container":"LineText_container__our9t"};